var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress m-t-10"},[_c('div',{staticClass:"progress-bar",class:{ 'bg-success': _vm.progress < 100, 'bg-danger': _vm.progress >= 100 },style:(`width: ${_vm.progress}%`),attrs:{"role":"progressbar"}},[_vm._v(" "+_vm._s(_vm.current)+"/"+_vm._s(_vm.max)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }